import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import query from '../../utils/query'
import privacyPolicy from './richText/PrivacyPolicy'
import userAgreement from './richText/UserAgreement'
import '@/css/base/reset.scss'
import '@/css/base/animation.scss'
import './index.scss'
import UserServiceAgreement from './richText/UserServiceAgreement'
import Autoprotection from './richText/Autoprotection'
import trafficWaterfall from './richText/trafficWaterfall'
import ServiceAgreement from './richText/ServiceAgreement'
import Moments from './richText/Moments'


/**
 * type:0 隐私政策
 * type:1 用户协议
 * type:2 用户服务协议
 * type:3 隐私政策 - 深圳市车安达汽保设备有限公司
 * type:4
 * type:5 智能体套餐/账号购买服务协议
 * type:6 朋友圈运营次数购买说明
 */

class App extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            type: 0
        }
    }
    render() {
        const { type } = this.state
        return (
            <div className='rich-text-wrapper'>
                <div dangerouslySetInnerHTML={{ __html: [privacyPolicy, userAgreement, UserServiceAgreement, Autoprotection, trafficWaterfall, ServiceAgreement, Moments][type] }}></div>
            </div>
        )
    }
    componentDidMount() {
        const type = query('type') || 0
        this.setState({
            type
        })
    }

}

ReactDOM.render(<App />, document.querySelector('#app'));